import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { PriceInputComponent } from './price-input.component';

@NgModule({
  imports: [CommonModule, FormsModule],
  declarations: [PriceInputComponent],
  exports: [PriceInputComponent],
  providers: [],
})
export class PriceInputModule {}
